import { Link, Typography } from '@ace-clublabs/shared-component-library';

export interface IPrivacyPolicyDisclaimerProps {
  textVariant?: string;
}

export const PrivacyPolicyDisclaimer = ({ textVariant }: IPrivacyPolicyDisclaimerProps) => {
  return (
    <Typography
      className="privacy-policy-disclaimer"
      variant={(textVariant as any) ?? 'b2Regular'}
      sx={{ color: '#404040' }}
    >
      The privacy and security of your information is important to us.{' '}
      <Link
        className="privacy-policy-link"
        variant={(textVariant as any) ?? 'b2Regular'}
        onClick={() => window.open('https://www.ace.aaa.com/legal/app-privacy-policy.html', '_blank')}
      >
        Privacy policy
      </Link>
    </Typography>
  );
};
